// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__fo08K","name":"ConsentHeader_name__2HvwO","birthday":"ConsentHeader_birthday__34WwX","skeleton":"ConsentHeader_skeleton__OTXFG"};